import {sharedCampaigns} from '@cl/shared';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {DTDistributionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';

function createDefaultDistributionCard(): DTDistributionNode {
  return {
    id: NO_NODE_ID,
    name: 'Distribution Card',
    description: '',
    type: NodeType.DISTRIBUTION,
    x: 0,
    y: 0,
    outputs: [
      {id: 1, name: 'Output 1', nodeId: NO_NODE_ID},
      {id: 2, name: 'Output 2', nodeId: NO_NODE_ID},
    ],
    inputs: [],
  };
}

/**
 * Gets an existing distribution card by ID, or creates a new default one.
 * @param cardId - The card ID to fetch, or 0 for a new card
 * @returns The distribution card (existing or new)
 */
async function getOrCreateDistributionCard(
  cardId: number,
  _store: CLStore,
): Promise<DTDistributionNode> {
  const resolvedCardId = cardId && cardId > NO_NODE_ID ? cardId : NO_NODE_ID;

  if (resolvedCardId) {
    const existingCard = sharedCampaigns.nodesRef.value[resolvedCardId];

    if (!existingCard) {
      throw new Error(`Card with id ${resolvedCardId} not found`);
    }

    if (existingCard.type !== NodeType.DISTRIBUTION) {
      throw new Error(`Card with id ${resolvedCardId} is not a distribution card`);
    }

    return existingCard as DTDistributionNode;
  }

  return createDefaultDistributionCard();
}

export default getOrCreateDistributionCard;
export {createDefaultDistributionCard};
